import {
  jb_section_headline_css_default
} from "./chunk.5MBTQKPK.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-section-headline/jb-section-headline.ts
var JbSectionHeadline = class extends i {
  render() {
    return b`<div class="${e({ left: this.headlineAlign === "left" })}">
      <jb-heading variant="section-heading">${this.headline}</jb-heading>
      ${this.languageBadge ? b`<span>${this.languageBadge}</span>` : A}
    </div>`;
  }
};
JbSectionHeadline.styles = [reset_css_default, jb_section_headline_css_default];
__decorateClass([
  n({ reflect: true })
], JbSectionHeadline.prototype, "headline", 2);
__decorateClass([
  n({ reflect: true })
], JbSectionHeadline.prototype, "headlineAlign", 2);
__decorateClass([
  n()
], JbSectionHeadline.prototype, "languageBadge", 2);
JbSectionHeadline = __decorateClass([
  customElement("jb-section-headline")
], JbSectionHeadline);

export {
  JbSectionHeadline
};
